export default {
  specialCharacters: new RegExp(/[&/\\#, +()$~%.'":*?<>{}\s]/g),
};
